export enum Routes {
    // Employes
    employes_list = "#/app/employe",
    employe_page = "#/app/employe/",
    // Interventions
    interventions_list = "#/app/intervention",
    intervention_list_filter = "#/app/intervention/filter/",
    intervention_print_planning = "#/app/intervention/print/planning",
    // Contact
    contact_list = "#/app/client",
    new_contact = "#/app/client/0",
}
